import { mergeQueryKeys } from '@lukemorales/query-key-factory';

import { agents } from './agents';
import { apiKeys } from './apiKeys';
import { approvalRequests } from './approvalRequests';
import { assignments } from './assignments';
import { backendValidation } from './backendValidation';
import { contracts } from './contracts';
import { countries } from './countries';
import { customerGroups } from './customerGroups';
import { customers } from './customers';
import { demandDefinitions } from './demandDefinitions';
import { demandInformation } from './demandInformation';
import { enums } from './enums';
import { intelligence } from './intelligence';
import { keyPorts } from './keyPorts';
import { mariAppsFailedRequisitions } from './mariAppsFailedRequisitions';
import { members } from './members';
import { mfa } from './mfa';
import { offers } from './offers';
import { onePortProductCatalogue } from './onePortProductCatalogue';
import { orders } from './orders';
import { packagePrices } from './packagePrices';
import { ports } from './ports';
import { priceAvailability } from './priceAvailability';
import { priceCompare } from './priceCompare';
import { products } from './products';
import { reports } from './reports';
import { requestsForQuotes } from './requestForQuotes';
import { role } from './role';
import { schedules } from './schedules';
import { supplierGroups } from './supplierGroups';
import { supplierOnboarding } from './supplierOnboarding';
import { suppliers } from './suppliers';
import { supplierSubscriptionPlans } from './supplierSubscriptionPlans';
import { supplierSubscriptionReleaseFlags } from './supplierSubscriptionReleaseFlags';
import { vessels } from './vessels';
import { webhooks } from './webhooks';

export const queries = mergeQueryKeys(
    agents,
    apiKeys,
    approvalRequests,
    assignments,
    backendValidation,
    countries,
    customerGroups,
    customers,
    demandDefinitions,
    demandInformation,
    enums,
    keyPorts,
    contracts,
    mfa,
    offers,
    onePortProductCatalogue,
    orders,
    packagePrices,
    ports,
    priceAvailability,
    priceCompare,
    products,
    reports,
    requestsForQuotes,
    role,
    schedules,
    supplierGroups,
    supplierSubscriptionPlans,
    supplierOnboarding,
    supplierSubscriptionReleaseFlags,
    suppliers,
    vessels,
    members,
    webhooks,
    intelligence,
    mariAppsFailedRequisitions
);
